import styles from '~/styles/wrapper/screen/screen.module.scss'
import { ChildProps } from '~/common/define/props'
import { addClass } from '~/common/utils/html'

import { useNotificationExist } from '~/hooks/server/notification'

interface Props extends ChildProps {
  origin?: boolean
}

const NavigationPageFrame = ({children, origin = false}: Props) => {
  // FIXME: for notification header
  const notificationExists = useNotificationExist()

  return (
    <div className={styles.navigation
      + addClass(origin ? notificationExists ? styles.originNotification : styles.originStandard : styles.space)}>
      {children}
    </div>
  )
}

export default NavigationPageFrame